import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiModule } from '../shared/ui/ui.module';

import { PagesRoutingModule } from './pages-routing.module';

import { NgbNavModule, NgbDropdownModule, NgbTooltipModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DndModule } from 'ngx-drag-drop';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserComponent } from './user/user.component';
import { BoardComponent } from './board/board.component';
import { CabinetComponent } from './cabinet/cabinet.component';
import { LocationComponent } from './location/location.component';
import { SalesRepComponent } from './salesrep/salesrep.component';
import { ActivationComponent } from './activation/activation.component';
import { BoardReadComponent } from './boardRead/boardRead.component';
import { GameComponent } from './game/game.component';
import { BoardTypeComponent } from './boardType/boardType.component';
import { PrinterTypeComponent } from './printerType/printerType.component';
import { NgSelectModule } from '@ng-select/ng-select';

import { ToastrModule } from 'ngx-toastr'
import { FileUploadComponent } from './file-upload/file-upload.component';
import { CoreModule } from '../core/core.module';
import { MonitorTypeComponent } from './monitorType/monitorType.component';
import { BvTypeComponent } from './bvType/bvType.component';
import { HarnessTypeComponent } from './HarnessType/harnessType.component';
import { CabinetTypeComponent } from './cabinetType/cabinetType.component';
import { BoardStatsComponent } from './boardStats/boardStats.component';
import { BoardStatsByIdComponent } from './boardStatsById/boardStatsById.component';
import { BoardStatsDashboardComponent } from './boardStatDashBoard/boardStatsDashBoard.component';
import { LocationDashboardComponent } from './locationDashboard/locationDashboard.component';
import { BoardStatsReportComponent } from './board-stats-report/board-stats-report.component';
import { CollectionModalComponent } from './collectionModal/collection-modal.component';
import { CollectionSummaryComponent } from './collectionSummary/collection-summary.component';
import { PendingCollectionsComponent } from './pending-collections/pending-collections.component';
import { LeadModalComponent } from './dashboard/lead-modal/lead-modal.component';
import { StateGameStatsComponent } from './dashboard/state-game-stats/state-game-stats.component';

import { NgxMaskDirective, provideNgxMask, NgxMaskPipe  } from 'ngx-mask';
import { SalesRepGameStatsComponent } from './dashboard/sales-rep-game-stats/sales-rep-game-stats.component';
import { FusionConnectComponent } from './fusion-connect/fusion-connect.component';
import { FusionConnectStatsComponent } from './fusion-connect-stats/fusion-connect-stats.component';
import { DashboardSelectorComponent } from './dashboard-selector/dashboard-selector.component';
import { InternalDashboardComponent } from './internal-dashboard/internal-dashboard.component';
import { InventoryComponent } from './inventory/inventory.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 0.3
};

const TOAST_OPTIONS = {
  positionClass: 'toast-close-button'
}

@NgModule({
  declarations: [
    DashboardComponent, UserComponent, BoardComponent, CabinetComponent, LocationComponent, SalesRepComponent, 
    ActivationComponent, BoardReadComponent, GameComponent, BoardTypeComponent, FileUploadComponent,
    PrinterTypeComponent, MonitorTypeComponent, BvTypeComponent, HarnessTypeComponent, CabinetTypeComponent,
    BoardStatsComponent, BoardStatsByIdComponent, BoardStatsDashboardComponent, LocationDashboardComponent, BoardStatsReportComponent,
    CollectionModalComponent, CollectionSummaryComponent, PendingCollectionsComponent, LeadModalComponent, SalesRepGameStatsComponent,
    StateGameStatsComponent, FusionConnectComponent, FusionConnectStatsComponent, DashboardSelectorComponent,
    InternalDashboardComponent, InventoryComponent,
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    NgbDatepickerModule,
    FormsModule,
    ToastrModule.forRoot(TOAST_OPTIONS),
    ReactiveFormsModule,
    PagesRoutingModule,
    UiModule,
    Ng2SearchPipeModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    PerfectScrollbarModule,
    DndModule,
    FullCalendarModule,
    LeafletModule,
    CoreModule,
    NgxMaskDirective,
    NgxMaskPipe,

  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    DatePipe,
    provideNgxMask(),
  ]
})
export class PagesModule { }
